import * as React from 'react';
import { Avatar, Divider, Grid, Link, ListItem, ListItemAvatar, ListItemText, Typography } from '@material-ui/core';


export class EventPayoutFailedNotification extends React.Component<IPortalUserNotificationProps> {
    state = {
        dismissed: false,
    }

    HandleDismissClick = async () => {
        this.props.dismissNotification(this.props.notificationId);
        this.setState({...this.state, dismissed: true});
    }

    HandleChangePage =  ()=>{
        this.props.changePage(`/event?id=${this.props.entityId}&tab=2&showfinancials=0`);
    }

    render() {
        return (
            <div>
                {!this.state.dismissed && <div>
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                            <Avatar className='notification-avatar-red'>P</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Link href="#" onClick={this.HandleChangePage}>
                                        {this.props.title}</Link>
                                    <div style={{ float: 'right', fontSize: 'smaller' , marginLeft:'5px'}}>
                                        {this.props.createdAt.toDateString()}
                                    </div>
                                </React.Fragment>}
                            secondary={
                                <React.Fragment>
                                    {"Payout failed"}
                                    <Grid container justify="flex-end">
                                        <Link href="#" onClick={this.HandleDismissClick}>Dismiss</Link>
                                    </Grid>
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </div>}
            </div>
        );
    }
}